module.exports = __webpack_public_path__ + "img/align-center.fa2869e5.svg";